var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uploadView" },
    [
      _c(
        "el-upload",
        {
          attrs: {
            action: "#",
            accept: _vm.accept,
            "http-request": _vm.upload,
            "show-file-list": false,
            multiple: _vm.multiple,
            drag: "",
            "file-list": _vm.fileList,
            limit: _vm.limit,
            "on-exceed": _vm.onExceed,
            "before-upload": _vm.beforeVideoUpload,
          },
        },
        [
          _c("div", { staticClass: "upload_image_poster" }, [
            _c("i", { staticClass: "el-icon-upload2 addimag_icon" }),
            _c("span", [_vm._v("上传文件")]),
          ]),
          _c(
            "div",
            { staticClass: "upload_tips", attrs: { slot: "tip" }, slot: "tip" },
            [
              _c("div", [
                _vm._v(" 最多可上传10个文件，每个文件最大不超过5M。"),
                _c("br"),
                _vm._v("支持doc、docx、pdf、Excel、txt文件格式 "),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "fileList" },
        [
          _vm._l(_vm.fileList, function (item, index) {
            return [
              _c(
                "div",
                { key: `image_${index}`, staticClass: "image_poster_box" },
                [
                  [
                    _c(
                      "div",
                      { staticClass: "image_poster" },
                      [
                        _c("fileList", {
                          attrs: {
                            config: _vm.config,
                            url: item.status === 3 ? item.url : item.name,
                            status: item.status,
                          },
                          on: {
                            del: function ($event) {
                              return _vm.delFile(item, index)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "progress" },
                      [
                        item.status !== 3
                          ? _c("el-progress", {
                              attrs: {
                                "stroke-width": 4,
                                "show-text": false,
                                percentage: item.authProgress,
                                color:
                                  item.status !== 2 ? "#5696FF" : "#F54B4B",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }